import angular from 'angular'
import mediaPickerDirective from './media-picker-directive'

export default angular
  .module('ellipsis.mediaPicker', [])
  .directive('mediaPicker', mediaPickerDirective)
